export const eduInternDetailsTranslations = {
  lv: {
    plan: 'Prakses plāns',
    profession: 'Profesija',
    grader: 'Vērtētājs',
    planPoint: 'Plāna punkts',
    hours: 'Stundas',
    start: 'Sākums',
    end: 'Beigas',
    planError: 'Neizdevās ielādēt prakses plānu',
    graders: { Edu: 'Izglītības iestāde', Org: 'Prakses vieta', None: 'Bez vērtējuma' },
    hoursTitle: 'Stundu izpilde',
    hoursDone: 'Nostrādātās',
    hoursAbsent: 'Attaisnota prombūtne',
    hoursLeft: 'Atlikušās',
    hoursOf: '{{left}} h no {{planned}} h',
    hoursNote: 'Nostrādātās + attaisnotā prombūtne = izpildītās stundas pret programmas kopapjomu.',
    category: 'Kategorija',
    program: 'Programma',
    eduSupervisor: 'Prakses vadītājs izglītības iestādē',
    inputOpen: 'Ieraksts atvērts',
    daysBack_zero: '{{count}} dienas atpakaļ',
    daysBack_one: '{{count}} dienu atpakaļ',
    daysBack_other: '{{count}} dienas atpakaļ',
    weekLimit: 'Limits nedēļā',
    placements: {
      title: 'Prakses vietas',
      aside: 'Praktikants pie katra ieraksta izvēlas, uz kuru vietu tas attiecas',
      note: 'Rindas galā zem <strong>izvēlnes</strong> var mainīt prakses vadītāja datus līgumā, prakses datumus šajā vietā, izlabot e-pastu vai dzēst piesaisti. <strong>Prakses vadītāja konta datus izglītības iestāde nemaina</strong> — līgumā ir atsevišķa datu kopija.',
      empty: 'Nav prakses vietu',
      period: 'Periods',
      org: 'Prakses vieta',
      address: 'Adrese',
      supervisor: 'Prakses vadītājs',
      contacts: 'Kontakti',
      records: 'Ieraksti',
      answers: 'Anketa aizpildīta',
      yes: 'Jā',
      no: 'Nē',
      actions: 'Darbības',
      menuFor: 'Prakses vietas {{org}} darbības',
      actionItems: {
        editOrgSupervisor: 'Mainīt prakses vadītāja informāciju',
        editOrgSupervisorDates: 'Mainīt prakses vadītāja datumus',
        changeSupervisorAccount: 'Mainīt prakses vadītāja kontu',
        deleteOrgSupervisor: 'Dzēst',
      },
      changeAccount: {
        help: 'Prakses vieta pāriet uz norādīto kontu un uzņēmumu. Prakses vietā saglabātie prakses vadītāja un uzņēmuma dati, datumi un līgums nemainās.',
        saved: 'Prakses vadītāja konts mainīts',
        failed: 'Neizdevās mainīt prakses vadītāja kontu',
      },
      edit: {
        name: 'Vārds',
        lastname: 'Uzvārds',
        phone: 'Tālrunis',
        email: 'E-pasts',
        address: 'Adrese',
        orgName: 'Uzņēmuma nosaukums',
        regNo: 'Reģistrācijas numurs',
        signatory: 'Parakstītājs',
        legalAddress: 'Juridiskā adrese',
        required: 'Lauks nav aizpildīts',
        emailInvalid: 'Nepareizs e-pasts',
        help: 'Neparakstīts līgums saņem jaunos datus. Ja prakses vadītājs vēl nav pieslēdzies, tiek mainīts arī viņa konts; mainot e-pastu, uz jauno adresi tiek nosūtīta jauna parole.',
        save: 'Saglabāt',
        saved: 'Prakses vadītāja informācija saglabāta',
        loadFailed: 'Neizdevās ielādēt prakses vadītāja datus',
        saveFailed: 'Neizdevās saglabāt prakses vadītāja datus',
      },
      dates: {
        start: 'Sākums',
        end: 'Beigas',
        required: 'Lauks nav aizpildīts',
        order: 'Beigu datumam jābūt pēc sākuma datuma',
        help: 'Praktikanta prakses periods: {{start}} – {{end}}',
        save: 'Mainīt prakses termiņu',
        saved: 'Prakses vadītāja datumi mainīti',
        failed: 'Neizdevās mainīt prakses vadītāja datumus',
      },
      delete: {
        title: 'Dzēst prakses vadītāju',
        confirm: 'Vai vēlaties dzēst prakses vadītāju?',
        submit: 'Dzēst',
        deleted: 'Prakses vadītājs dzēsts',
        failed: 'Neizdevās dzēst prakses vadītāju',
      },
    },
    applications: {
      title: 'Pieteikumi',
      aside: 'Praktikanta aktīvie pieteikumi vakancēm',
      empty: 'Nav pieteikumu',
      sent: 'Nosūtīts',
      org: 'Uzņēmums',
      vacancy: 'Vakance',
      contacts: 'Kontakti',
      motivation: 'Motivācija',
    },
    header: {
      place: 'Prakses vieta',
      eduSupervisor: 'Vadītājs iestādē',
    },
    tabs: {
      agreement: 'Līgums',
      plan: 'Individuālais plāns',
      absence: 'Prombūtne',
      log: 'Notikumu žurnāls',
      activeAbsence: 'aktīva',
    },
    agreements: {
      agreement: 'Līgums',
      waiting: 'Gaida',
      order: 'Parakstīšanas secība ir stingra',
      orderSteps: 'izglītības iestāde → praktikants → prakses vieta.',
      nextStep: 'Nākamais solis',
      steps: {
        toSignEdu: 'gaida izglītības iestādes parakstu',
        toSignIntern: 'gaida praktikanta parakstu',
        toSignOrg: 'gaida prakses vietas parakstu',
      },
      actions: {
        sendToSign: 'Nosūtīt parakstīšanai',
        signAtEparaksts: 'Parakstīt eParakstā',
      },
      send: {
        description:
          'Parakstīs: {{party}}. Saite tiks nosūtīta uz norādīto e-pastu, un saņēmējs to atvērs, ievadot šo pašu e-pastu.',
      },
    },
    individualPlan: {
      note: 'Individuālais plāns ir <strong>prakses programmas kopija šim praktikantam</strong>. To var pielāgot, ja students iet praksi vairākās vietās vai pēc individuāla mācību plāna.',
      search: 'Meklēt punktu...',
      empty: 'Nav plāna punktu',
      inactive: 'neaktīvs',
      item: 'Plāna punkts',
      planned: 'Plānotās',
      done: 'Nostrādātās',
      left: 'Atlikušās',
      records: 'Ieraksti',
      progress: 'Izpilde',
    },
    absences: {
      total: 'Kopā prombūtnē',
      creditedHours: 'Ieskaitītas stundas',
      creditedHoursNote: 'Pieskaitīts izpildītajām',
      current: 'Šobrīd prombūtnē',
      since: 'No {{date}}',
      notAbsent: 'Nav aktīvas prombūtnes',
      days: '{{value}} d.',
      start: 'No',
      end: 'Līdz',
      dayCount: 'Dienas',
      type: 'Iemesls',
      info: 'Iestādes piezīme',
      infoForOrg: 'Informācija prakses vietai',
      infoConclusion: 'Noslēguma piezīme',
      hours: 'Ieskaitītas h',
      open: 'nav noslēgta',
      empty: 'Nav reģistrēta neviena prombūtne',
      add: 'Pievienot prombūtni',
      actions: 'Darbības',
      menuFor: 'Prombūtnes no {{date}} darbības',
      close: 'Noslēgt',
      delete: 'Dzēst',
      deleteTitle: 'Dzēst prombūtni',
      confirmDelete: 'Dzēst prombūtni no {{date}}?',
      deleted: 'Prombūtne dzēsta',
      deleteFailed: 'Neizdevās dzēst prombūtni',
    },
    log: {
      date: 'Datums',
      type: 'Notikums',
      user: 'Lietotājs',
      org: 'Organizācija',
      info: 'Info',
      empty: 'Nav notikumu',
    },
  },
  en: {
    plan: 'Practice plan',
    profession: 'Profession',
    grader: 'Grader',
    planPoint: 'Plan item',
    hours: 'Hours',
    start: 'Start',
    end: 'End',
    planError: 'Could not load practice plan',
    graders: { Edu: 'Educational institution', Org: 'Workplace', None: 'Not graded' },
    hoursTitle: 'Hours progress',
    hoursDone: 'Worked',
    hoursAbsent: 'Excused absence',
    hoursLeft: 'Remaining',
    hoursOf: '{{left}} h of {{planned}} h',
    hoursNote: 'Worked + excused absence = completed hours against the program total.',
    category: 'Category',
    program: 'Program',
    eduSupervisor: 'Supervisor at the educational institution',
    inputOpen: 'Entries open',
    daysBack_one: '{{count}} day back',
    daysBack_other: '{{count}} days back',
    weekLimit: 'Weekly limit',
    placements: {
      title: 'Internship places',
      aside: 'For each entry the intern chooses which place it belongs to',
      note: "Under the <strong>menu</strong> at the end of a row you can change the supervisor's details in the agreement, the internship dates at this place, correct the e-mail or remove the assignment. <strong>The educational institution does not change the supervisor's account data</strong> — the agreement holds a separate copy of the data.",
      empty: 'No internship places',
      period: 'Period',
      org: 'Internship place',
      address: 'Address',
      supervisor: 'Supervisor',
      contacts: 'Contacts',
      records: 'Entries',
      answers: 'Survey completed',
      yes: 'Yes',
      no: 'No',
      actions: 'Actions',
      menuFor: 'Actions for the internship place {{org}}',
      actionItems: {
        editOrgSupervisor: 'Change supervisor info',
        editOrgSupervisorDates: 'Change supervisor dates',
        changeSupervisorAccount: 'Change supervisor account',
        deleteOrgSupervisor: 'Delete',
      },
      changeAccount: {
        help: 'The internship place moves to the chosen account and company. The supervisor and company data stored on the place, its dates and its agreement stay as they are.',
        saved: 'Supervisor account changed',
        failed: 'Could not change the supervisor account',
      },
      edit: {
        name: 'First name',
        lastname: 'Last name',
        phone: 'Phone',
        email: 'E-mail',
        address: 'Address',
        orgName: 'Company name',
        regNo: 'Registration number',
        signatory: 'Signatory',
        legalAddress: 'Legal address',
        required: 'Field not filled',
        emailInvalid: 'Invalid e-mail',
        help: 'An unsigned agreement takes the new data. If the supervisor has not signed in yet, their account changes too; a changed e-mail gets a new password sent to the new address.',
        save: 'Save',
        saved: 'Supervisor info saved',
        loadFailed: "Could not load the supervisor's data",
        saveFailed: "Could not save the supervisor's data",
      },
      dates: {
        start: 'Start',
        end: 'End',
        required: 'Field not filled',
        order: 'The end date must be after the start date',
        help: "The intern's internship period: {{start}} – {{end}}",
        save: 'Change the internship term',
        saved: 'Supervisor dates changed',
        failed: "Could not change the supervisor's dates",
      },
      delete: {
        title: 'Delete supervisor',
        confirm: 'Do you want to delete the supervisor?',
        submit: 'Delete',
        deleted: 'Supervisor deleted',
        failed: 'Could not delete the supervisor',
      },
    },
    applications: {
      title: 'Applications',
      aside: "The intern's active vacancy applications",
      empty: 'No applications',
      sent: 'Sent',
      org: 'Company',
      vacancy: 'Vacancy',
      contacts: 'Contacts',
      motivation: 'Motivation',
    },
    header: {
      place: 'Internship place',
      eduSupervisor: 'School supervisor',
    },
    tabs: {
      agreement: 'Agreement',
      plan: 'Individual plan',
      absence: 'Absence',
      log: 'Event log',
      activeAbsence: 'active',
    },
    agreements: {
      agreement: 'Agreement',
      waiting: 'Waiting',
      order: 'The signing order is fixed',
      orderSteps: 'institution → intern → workplace.',
      nextStep: 'Next step',
      steps: {
        toSignEdu: 'waiting for the institution’s signature',
        toSignIntern: 'waiting for the intern’s signature',
        toSignOrg: 'waiting for the workplace’s signature',
      },
      actions: {
        sendToSign: 'Send for signing',
        signAtEparaksts: 'Sign with eParaksts',
      },
      send: {
        description:
          'Signs: {{party}}. The link is sent to this email, and the recipient opens it by typing the same email.',
      },
    },
    individualPlan: {
      note: 'The individual plan is <strong>a copy of the internship program for this intern</strong>. It can be adjusted when the student interns at several places or follows an individual study plan.',
      search: 'Search items...',
      empty: 'No plan items',
      inactive: 'inactive',
      item: 'Plan item',
      planned: 'Planned',
      done: 'Worked',
      left: 'Remaining',
      records: 'Entries',
      progress: 'Progress',
    },
    absences: {
      total: 'Total absence',
      creditedHours: 'Credited hours',
      creditedHoursNote: 'Added to completed work',
      current: 'Absent now',
      since: 'Since {{date}}',
      notAbsent: 'No active absence',
      days: '{{value}} d.',
      start: 'From',
      end: 'To',
      dayCount: 'Days',
      type: 'Reason',
      info: 'School note',
      infoForOrg: 'Information for the workplace',
      infoConclusion: 'Closing note',
      hours: 'Credited h',
      open: 'not closed',
      empty: 'No absence registered',
      add: 'Add absence',
      actions: 'Actions',
      menuFor: 'Actions for the absence from {{date}}',
      close: 'Close',
      delete: 'Delete',
      deleteTitle: 'Delete absence',
      confirmDelete: 'Delete the absence from {{date}}?',
      deleted: 'Absence deleted',
      deleteFailed: 'Could not delete the absence',
    },
    log: {
      date: 'Date',
      type: 'Event',
      user: 'User',
      org: 'Organization',
      info: 'Info',
      empty: 'No events',
    },
  },
}
